import { useMemo } from 'react';
import { useMultimediaLevelsList } from '../../../../hooks/multimediaLevel/useMultimediaLevelsList.js';
import MultimediaLevelTable from '../../../../components/tables/unitsLevels/MultimediaLevelTable.jsx';
import SearchBar from '../../../../components/utils/SearchBar.jsx';
import Pagination from '../../../../components/utils/Pagination.jsx';
import ErrorModal from '../../../../components/modales/ErrorModal.jsx';

export default function ListMultimediaLevels() {
    // Traer listas
    const {
        multimediaLevels,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        sortField,
        sortOrder,
        handleSort
    } = useMultimediaLevelsList();

    // FILTRO POR BÚSQUEDA
    const filteredMultimediaLevels = useMemo(() => {
        const search = searchTerm.toLowerCase();

        return multimediaLevels.filter(multimediaLevel => {
            return (
                (multimediaLevel.name || '').toLowerCase().includes(search));
        });
    }, [multimediaLevels, searchTerm]);

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentMultimediaLevels = filteredMultimediaLevels.slice(indexOfFirstItem, indexOfLastItem);
    
    return (
        <>
            <div className='container-fluid mt-6'>
                <h1 className='text-center mt-5 mb-5'>Niveles multimedia</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />
                <MultimediaLevelTable
                    multimediaLevels={currentMultimediaLevels}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    handleSort={handleSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                />
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredMultimediaLevels.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />
                <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            </div>
        </>
    );
}